import { useLocation } from 'react-router-dom';
import { SessionShell, SessionHeader, Panel, PanelTitle, PanelText } from '../../ui';

/**
 * Full-page message in the IBISengage chrome ("Session closed", "This appointment is not available.").
 * Rendered by the /error route for both layouts; reads { title, error } from the navigation state.
 */
export const SessionMessage = ({ title, message }) => {
  const location = useLocation();
  const heading = title || location?.state?.title || 'Something went wrong';
  const text = message ?? location?.state?.error ?? null;
  return (
    <SessionShell header={<SessionHeader title='IBISengage Appointment' showLogo />}>
      <div style={{ display: 'flex', width: '100%', maxWidth: 720, minHeight: 280, margin: '6vh auto 0' }}>
        <Panel data-testid='session-message'>
          <div style={{ margin: 'auto 0' }}>
            <PanelTitle>{heading}</PanelTitle>
            {text && <PanelText>{text}</PanelText>}
          </div>
        </Panel>
      </div>
    </SessionShell>
  );
};

export default SessionMessage;
